import React, { FC } from 'react';
import { useDrop } from 'react-dnd';
import imageSources from '../../../../../../constants/imageSources/imageSources';
import ImportDropZoneBackground from './ImportDropZoneBackground';
import * as itemTypes from '../../../../../../constants/itemTypes/itemTypes';
import * as Styled from './styles';
import { populateThirdPartyBlock } from '../../../../../../common/populateThirdPartyBlock';

interface IProps {
    blockIndex: string;
    columnIdx: string;
}

const ColumnItemImportPlaceholderDropZone: FC<IProps> = ({ blockIndex, columnIdx }) => {
    const [{ isOverCurrent, canDrop }, drop] = useDrop({
        accept: itemTypes.STAFFBASE_POST,
        drop: ({ contents }: any) => {
            populateThirdPartyBlock({ blockIndex, columnIdx, contents });
        },
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            isOverCurrent: monitor.isOver({ shallow: true }),
            canDrop: monitor.canDrop(),
        }),
    });

    if (!canDrop) {
        return <ImportDropZoneBackground />;
    }

    return (
        <div
            ref={drop}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundImage: isOverCurrent
                    ? `url("${imageSources.DROP_ZONE.ELEMENT.HIGHLIGHTED}")`
                    : `url("${imageSources.DROP_ZONE.ELEMENT.NOT_HIGHLIGHTED}")`,
                outline: 'none',
            }}
        >
            <Styled.PlaceholderDropzoneText>Drop thumbnail here</Styled.PlaceholderDropzoneText>
        </div>
    );
};

export default ColumnItemImportPlaceholderDropZone;
